export const paths = {
  authorizationToken: '/iphone_spa/oauth/authorization_token',
  iphoneRegistrationToken: '/iphone_spa/oauth/iphone_registration_token',
};
